<template>
  <div class="photo-upload" ref="upload-wrapper">
    <div class="controls">
      <el-button
        icon="el-icon-camera"
        size="small" v-on:click.stop="takePhoto">
        <!-- 拍照 -->
        拍照
      </el-button>
      <el-button
        icon="el-icon-refresh"
        size="small" v-on:click.stop="reset">
        <!-- 重置 -->
        重置
      </el-button>
      <el-button
        icon="el-icon-upload"
        size="small" v-on:click.stop="upload">
        <!-- 上传 -->
        上传
      </el-button>
      <el-select v-model="size" class="input150 ml10" :placeholder="`像素尺寸`" @change="replay()">
        <el-option
          v-for="item in photoOption"
          :key="item.value"
          :label="item.name"
          :value="item.name">
        </el-option>
      </el-select>
    </div>
    <div class="camera">
      <video autoplay playsinline="true" class="videoDom" id="videoDom" :width="camera.width" :height="camera.height"></video>
      <canvas :width="camera.width" :height="camera.height" class="canvasDom" id="canvasDom"></canvas>
    </div>
    <div class="photo-list">
      <div v-for="(p, i) in photoList" :key="i" class="photo-thumb">
        <img :src="p.url" class="image">
        <span class="img-mask">
          <span
            @click="handlePreview(p.url)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            @click="handleRemove(i, p.url)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </div>
    <el-image-viewer :z-index="9999" v-if="preview.show" :on-close="preview.close" :url-list="[preview.url]"></el-image-viewer>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { getDict } from '@/api.js'
export default {
  name: 'PhotoUpload',
  components: {
    ElImageViewer
  },
  data() {
    return {
      camera: {
        width: 0,
        height: 0
      },
      photoList: [],
      preview: {
        url: '',
        show: false,
        close: () => {
          this.preview.show = false,
          this.preview.url = ''
        }
      },
      videoDom: null,
      canvasDom: null,
      canvasContext: null,
      size: '',
      photoOption: [],
      defaultWidth: 960,
      defaultHeight: 540,
      takeLoading: null,
      videoTrack: null,
      setWitdh: 0,
      setHeight: 0
    }
  },
  // created() {
  //   if (!this.photoOption.length) {
  //     this.getPixelSize()
  //   }
  // },
  async mounted() {
    if (!this.photoOption.length) {
      await this.getPixelSize()
    }
    this.reset()
    this.initSize()
    this.checkAndPlay()
  },
  beforeDestroy() {
    this.closeCamera()
  },
  methods: {
    initSize() {
      // 初始化尺寸
      const wrapper = this.$refs['upload-wrapper']
      if (wrapper) {
        const sizeObj = window.getComputedStyle(wrapper)
        const prop = 400/700
        const width = parseInt(sizeObj.width)
        const height = prop * width
        this.camera = {
          width, height
        }
      }
    },
    async checkAndPlay() {
      // 检查浏览器兼容性并准备拍照
      this.canvasDom = document.getElementById('canvasDom')
      this.videoDom = document.getElementById('videoDom')
      this.canvasContext = this.canvasDom.getContext('2d')
      if (navigator.mediaDevices === undefined) {
          navigator.mediaDevices = {};
      }

      if (navigator.mediaDevices.getUserMedia === undefined) {
          navigator.mediaDevices.getUserMedia = (constraints) => {
              let getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia;
              
              if (!getUserMedia) {
                  return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
              }

              return new Promise((resolve, reject) => {
                  getUserMedia.call(navigator, constraints, resolve, reject)
              })
          }
      }

      const widthSize = this.defaultWidth
      const heightSize = this.defaultHeight
      const w = this.size.split('*')[0] || widthSize
      const h = this.size.split('*')[1] || heightSize

      this.setWitdh = Number(w)
      this.setHeight = Number(h)

      const constraints = {
          audio: false,
          // video: {width: this.camera.width*1.5, height: this.camera.height*1.5, transform: 'scaleX(-1)'}
          video: {
            // width: { min: 192, ideal: this.camera.width*1.5, max: 1920 },
            // height: { min: 108, ideal: this.camera.height*1.5, max: 1080 },
            width: this.setWitdh,
            height: this.setHeight,
            frameRate: { min: 1, ideal: 60, max: 120 },
            // aspectRatio: 1920/1080,
            // resizeMode: 'crop-and-scale',
            facingMode: 'environment',
            transform: 'scaleX(-1)'
          }
      }

      try {
        navigator.mediaDevices.getUserMedia(constraints)
        .then(this.handleSuccess)
      } catch (error) {
        console.log(error)
        this.$notify({
          // 警告
          title: `警告`,
          // 没有开启摄像头权限或浏览器版本不兼容
          message: `没有开启摄像头权限或浏览器版本不兼容`,
          type: 'warning'
        });
      }
    },
    handleSuccess(stream) {
      if (this.videoDom.srcObject !== undefined) {
        this.videoDom.srcObject = stream;
      } else if (window.videoEl.mozSrcObject !== undefined) {
        this.videoDom.mozSrcObject = stream;
      } else if (window.URL.createObjectURL) {
        this.videoDom.src = window.URL.createObjectURL(stream);
      } else if (window.webkitURL) {
        this.videoDom.src = window.webkitURL.createObjectURL(stream);
      } else {
        this.videoDom.src = stream;
      }
      this.videoDom.playsInline = true;
      this.videoTrack = stream.getVideoTracks()[0]
    },
    closeLoading() {
      if (this.takeLoading) {
        this.takeLoading.close()
        this.takeLoading = null
      }
    },
    convertBitmapToBlob(bitmap) {
      // 将bitmap转为blob
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        const { width, height } = bitmap
        canvas.width = width
        canvas.height = height
        context.drawImage(bitmap, 0, 0, width, height)
        canvas.toBlob((blob) => {
          resolve(blob)
        })
      })
    },
    takePhoto() {
      // 拍照并获取图片文件
      if (window.ImageCapture) {
        this.takeLoading = this.takeLoading || this.$loading({
          lock: true,
          // 拍摄中
          text: `拍摄中`,
          fullscreen: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // const photoSettings = {
        //   fillLightMode: 'auto',
        //   imageWidth: this.setWitdh,
        //   imageHeight: this.setHeight,
        //   redEyeReduction: true
        // }
        const imageCapture = new ImageCapture(this.videoTrack)
        // imageCapture.takePhoto(photoSettings)
        imageCapture.grabFrame()
        .then(bitmap => {
          return this.convertBitmapToBlob(bitmap)
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const name = `${url.split('/')[url.split('/').length - 1]}.png`
          const item = {
            raw: blob,
            size: blob.size,
            url,
            name
          }

          this.photoList.push(item)

          this.$nextTick(() => {
            this.closeLoading()
          })
        })
        .catch(e => {
          console.error('拍照出错', e)
        })

        return
      }

      this.canvasContext.drawImage(this.videoDom, 0, 0, this.camera.width, this.camera.height)
      this.canvasDom.toBlob((blob) => {
        const url = URL.createObjectURL(blob)
        const name = `${url.split('/')[url.split('/').length - 1]}.png`
        const item = {
          raw: blob,
          size: blob.size,
          url,
          name
        }

        this.photoList.push(item)
      })
    },
    async upload() {
      // 按顺序上传图片
      const files = this.photoList
      const result = []
      if (files.length === 0) {
        // this.$message.error('请先拍照')
        this.$message.error(`请先拍照`)
        return
      }
      for (const file of files) {
        const item = {
          raw: file.raw,
          filename: file.name,
          size: file.size
        }

        const res = await this.$upload.start(item)
        result.push(res)
      }
      
      this.complete(result)
    },
    complete(list) {
      this.$emit('complete', list)
      this.reset()
    },
    reset() {
      this.photoList.forEach(i => {
        this.revokeUrl(i.url)
      })

      this.photoList = []
    },
    handlePreview(picture) {
      // 预览
      this.$set(this.preview, 'url', picture)
      this.$set(this.preview, 'show', true)
    },
    handleRemove(index, url) {
      // 移除
      this.photoList.splice(index, 1)

      this.revokeUrl(url)
    },
    closeCamera() {
      // 停止拍照
      if (this.videoDom) {
        this.videoDom.srcObject.getTracks().forEach(t => t.stop());
        this.videoDom = null
      }
    },
    revokeUrl(url) {
      URL.revokeObjectURL(url)
    },
    getPixelSize() {
      // 获取像素尺寸下拉框
      return this.$request('get', getDict, {type: 390})
			.then((res) => {
				this.photoOption = res
        const one = this.photoOption.filter(i => i.is_default === 1)[0] || {}
        this.size = one.name || ''
			})
    },
    replay() {
      // 重新执行摄像头
      this.closeCamera()
      this.checkAndPlay()
    }
  }
}
</script>

<style lang="scss" scoped>
  .photo-upload {
    .controls {

    }
    .camera {
      .canvasDom {
        display: none;
      }
    }
    .photo-list {
      display: flex;
      flex-wrap: wrap;
      .photo-thumb {
        width: 148px;
        height: 148px;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        margin: 8px;
        img {
          width: 100%;
          height: 100%;
        }
        .img-mask {
          display: none;
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: rgba($color: #000000, $alpha: 0.4);
          left: 0;
          top: 0;
          align-items: center;
          justify-content: center;
          span {
            margin: 0 10px;
            cursor: pointer;
            i {
              color: #fff;
              font-size: 24px;
            }
          }
        }
        &:hover {
          .img-mask {
            display: flex;
          }
        }
      }
    }
    .camera {
      video {
        margin: 10px auto 0;
        display: block;
      }
    }
  }
</style>